const bonding = {
  hero: {
    badge: "Ästhetische Zahnheilkunde",
    title: "Bonding (Zahnformung)",
    description:
      "Verwandeln Sie Ihr Lächeln mit unseren Experten-Bonding-Services. Wir verwenden modernste Techniken und zahnfarbenes Komposit, um beschädigte, verfärbte oder missgebildete Zähne zu reparieren und ein nahtloses, natürlich aussehendes Ergebnis zu erzielen, das Ihr Lächeln und Ihr Selbstvertrauen stärkt.",
    ctas: {
      primary: "Beratungstermin vereinbaren",
      secondary: "Mehr über den Prozess erfahren",
    },
    stats: {
      value1: "97%",
      value2: "4.9",
      title: "97% Patientenzufriedenheit",
      subtitle: "Basierend auf Patientenbewertungen",
    },
    imageAlt: "Dental Bonding-Verfahren",
  },
  benefits: {
    heading: "Vorteile von Dental Bonding",
    intro: "Entdecken Sie, warum Patienten Dental Bonding für ihre Lächeln-Transformation wählen",
    items: [
      {
        title: "Behandlung in einem Termin",
        description:
          "Schließen Sie Ihr Dental Bonding in nur einem Termin ab und sparen Sie Zeit ohne Kompromisse bei der Qualität.",
      },
      {
        title: "Minimalinvasiv",
        description:
          "Erhalten Sie mehr Ihrer natürlichen Zahnsubstanz mit dieser konservativen ästhetischen Behandlungsoption.",
      },
      {
        title: "Verbessertes Aussehen",
        description:
          "Verschönern Sie Ihr Lächeln, indem Sie abgebrochene Zähne reparieren, Lücken füllen und die Farbe an Ihre natürlichen Zähne anpassen.",
      },
      {
        title: "Natürlich aussehende Ergebnisse",
        description:
          "Unsere fachmännische Anpassung des Komposits an Ihre Zahnfarbe sorgt für nahtlose, unsichtbare Reparaturen.",
      },
      {
        title: "Sofortiges Selbstvertrauen",
        description:
          "Verlassen Sie die Praxis mit einem sofort verbesserten Lächeln, das Ihr Selbstwertgefühl und Selbstvertrauen stärkt.",
      },
      {
        title: "Vielseitige Lösung",
        description:
          "Gehen Sie mehrere ästhetische Probleme mit einer vielseitigen Behandlung an, die an Ihre Bedürfnisse angepasst werden kann.",
      },
    ],
    bottomLinePrefix: "Möchten Sie erfahren, ob Dental Bonding das Richtige für Sie ist?",
    bottomLineCta: "Vereinbaren Sie noch heute einen Beratungstermin.",
  },
  process: {
    heading: "Der Bonding-Prozess",
    intro: "Unser detaillierter Ansatz sorgt für schöne, natürlich aussehende Ergebnisse",
    steps: [
      {
        number: "01",
        title: "Beratung & Beurteilung",
        description:
          "Unser Zahnarzt untersucht Ihre Zähne, bespricht Ihre Ziele und stellt fest, ob Dental Bonding das Richtige für Sie ist.",
      },
      {
        number: "02",
        title: "Behandlungsplanung",
        description:
          "Wir wählen den idealen Farbton des Komposits aus, der zu Ihren natürlichen Zähnen passt, und planen das Bonding-Verfahren für optimale Ergebnisse.",
      },
      {
        number: "03",
        title: "Zahnvorbereitung",
        description:
          "Die Zahnoberfläche wird sanft angeraut und eine Konditionierungsflüssigkeit aufgetragen, damit das Bonding-Material haften kann.",
      },
      {
        number: "04",
        title: "Auftragen des Bondings",
        description:
          "Das zahnfarbene Komposit wird aufgetragen, in die gewünschte Form modelliert und mit einem speziellen Licht gehärtet.",
      },
      {
        number: "05",
        title: "Feinabstimmung",
        description:
          "Das gebondete Material wird getrimmt, geformt und poliert, um Ihren natürlichen Zähnen zu entsprechen und einen angenehmen Biss zu gewährleisten.",
      },
    ],
    expected: {
      heading: "Erwartete Ergebnisse",
      left: [
        "Natürlich aussehende Reparatur von abgebrochenen, rissigen oder verfärbten Zähnen",
        "Schließen kleiner Lücken zwischen den Zähnen",
        "Verbessertes Aussehen von missgebildeten Zähnen",
      ],
      right: [
        "Schutz freiliegender Zahnwurzeln aufgrund von Zahnfleischrückgang",
        "Sofortige Ergebnisse in nur einem Termin",
        "Verbessertes Erscheinungsbild des Lächelns und Selbstvertrauen",
      ],
    },
  },
  faq: {
    heading: "Häufig gestellte Fragen",
    intro: "Alles, was Sie über Dental Bonding wissen müssen",
    items: [
      {
        question: "Wie lange hält Dental Bonding?",
        answer:
          "Dental Bonding hält typischerweise zwischen 3 und 10 Jahren, abhängig von der Stelle des Bondings, Ihren Mundgewohnheiten und wie gut Sie Ihre Zähne pflegen. Regelmäßige zahnärztliche Kontrolluntersuchungen und gute Mundhygiene können helfen, die Lebensdauer des Bondings zu verlängern.",
      },
      {
        question: "Ist das Dental Bonding-Verfahren schmerzhaft?",
        answer:
          "Nein, Dental Bonding ist typischerweise ein schmerzloses Verfahren. In den meisten Fällen ist keine Anästhesie erforderlich, es sei denn, das Bonding wird verwendet, um einen kariösen Zahn zu füllen, der Zahn muss gebohrt werden, um seine Form zu ändern, oder der Bruch liegt nahe am Nerv.",
      },
      {
        question: "Wie viel kostet Dental Bonding?",
        answer:
          "Die Kosten für Dental Bonding variieren je nach Umfang des Verfahrens, der Anzahl der behandelten Zähne und Ihrem Standort. Im Allgemeinen ist es eine der erschwinglichsten verfügbaren ästhetischen Zahnbehandlungen. Wir bieten detaillierte Kostenschätzungen während Ihrer Beratung an.",
      },
      {
        question: "Wie lange dauert das Bonding-Verfahren?",
        answer:
          "Dental Bonding dauert normalerweise zwischen 30 und 60 Minuten pro Zahn. Der gesamte Prozess kann oft in einem einzigen Praxisbesuch abgeschlossen werden, was es zu einer bequemen Option für geschäftige Patienten macht.",
      },
      {
        question: "Wie pflege ich gebondete Zähne?",
        answer:
          "Pflegen Sie gebondete Zähne wie Ihre natürlichen Zähne mit regelmäßigem Putzen und Zahnseide. Vermeiden Sie das Beißen auf harte Gegenstände wie Eis, Stifte oder Fingernägel und begrenzen Sie den Konsum von verfärbenden Substanzen wie Kaffee, Tee und Tabak. Regelmäßige zahnärztliche Kontrollen sind für die Erhaltung Ihrer gebondeten Zähne unerlässlich.",
      },
      {
        question: "Kann Dental Bonding alle Arten von Zahnproblemen beheben?",
        answer:
          "Dental Bonding ist vielseitig, aber nicht für alle Zahnprobleme geeignet. Es eignet sich gut für kleinere kosmetische Verbesserungen, kleine Absplitterungen, Lücken und Verfärbungen. Für umfangreichere Schäden oder für Zähne, die starken Kaukräften ausgesetzt sind, könnten andere Behandlungen wie Veneers oder Kronen geeigneter sein.",
      },
      {
        question: "Ist Dental Bonding reversibel?",
        answer:
          "Ja, Dental Bonding ist im Allgemeinen reversibel, da nicht viel, wenn überhaupt, vom ursprünglichen Zahnschmelz entfernt werden muss. Wenn Sie sich in Zukunft für eine andere ästhetische Behandlung entscheiden, kann das Bonding-Material entfernt werden, ohne Ihren natürlichen Zahn dauerhaft zu schädigen.",
      },
    ],
    bottomLine: "Haben Sie noch Fragen zu Dental Bonding?",
    cta: "Kontaktieren Sie uns",
  },
};

export default bonding;

